"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDeleteFile = void 0;
var antd_1 = require("antd");
var react_1 = __importDefault(require("react"));
var icons_1 = require("@ant-design/icons");
var transifex_1 = require("../../../transifex");
// @TODO - make this a reusable component
var ConfirmDeleteFile = function () {
    return new Promise(function (res) {
        antd_1.Modal.confirm({
            content: (react_1.default.createElement("div", { style: { margin: "-8px -16px -14px 0px" } },
                react_1.default.createElement("div", { style: {
                        padding: "16px 24px",
                        background: "#111d2c",
                        color: "#fff",
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontWeight: 600,
                    } }, transifex_1.TX_DELETE_FILE),
                react_1.default.createElement("div", { style: { padding: "24px", borderBottom: "1px solid #f0f0f0" } },
                    react_1.default.createElement(antd_1.Alert, { message: transifex_1.TX_DELETE_FILE, description: transifex_1.TX_CONFIRM_DELETE_FILE, showIcon: true, type: "warning" })))),
            icon: react_1.default.createElement("div", null),
            closeIcon: react_1.default.createElement(icons_1.CloseOutlined, { style: { color: "#fff" } }),
            closable: true,
            maskClosable: true,
            maskStyle: { backgroundColor: "rgba(0,0,0,0.45)" },
            bodyStyle: { padding: "0px 16px 8px 0px" },
            onOk: function () { return res(true); },
            onCancel: function () { return res(false); },
        });
    });
};
exports.ConfirmDeleteFile = ConfirmDeleteFile;
